import { surpriseRanking } from "@/mocks/surpriseRanking";
import SectionHeading from "./SectionHeading";

export default function Ranking() {
  const rankStyles = [
    "bg-primary-500 text-background-50",
    "bg-secondary-500 text-background-50",
    "bg-accent-500 text-background-50",
  ];

  return (
    <section id="ranking" className="w-full">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="惊喜指数榜单"
              title="本期最让人意外的前六名"
              desc="惊喜指数综合了香气、口感、耐吃度与整体意外感。分数越高，表示这款零食在开箱时带来的正向反差越大。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="flex items-start gap-3 text-sm leading-relaxed text-foreground-600">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                  <i className="ri-information-line text-primary-600" />
                </span>
                榜单仅在相同批次的单品之间做比较，属于个人向的参考，不代表任何官方评价。
              </p>
            </div>
          </div>

          <ol className="space-y-4 lg:col-span-2">
            {surpriseRanking.map((item, index) => (
              <li
                key={item.rank}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base ${
                    rankStyles[index] ?? "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <h3 className="text-base font-medium text-foreground-950">
                      {item.name}
                    </h3>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                      {item.category}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {item.reason}
                  </p>
                  <div className="mt-3 flex items-center gap-3">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${item.score * 10}%` }}
                      />
                    </div>
                    <span className="shrink-0 font-heading text-sm text-primary-700">
                      {item.score.toFixed(1)}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}